import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Box, IconButton, Typography, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LinkIcon from '@mui/icons-material/Link';
import CheckIcon from '@mui/icons-material/Check';
import ShippingLoadContent from '../pages/ShippingLoadPage/ShippingLoadContent';
import { useAutoZ, ModalStackProvider } from '../utilities/ModalStackContext';
import { useTallDialogSizing } from '../utilities/dialogSizing';

const ShippingLoadModal = ({ open, loadId, onClose, onDeleted }) => {
  // useAutoZ allocates a fresh top-of-stack z each time the modal opens, so it
  // sits above whatever opened it (e.g. the car modal). A static z would render
  // behind any modal that opened later.
  const myZ = useAutoZ(open, loadId);
  const { fullScreen, paperSx } = useTallDialogSizing({ height: '90vh', margin: 4 });
  const [copied, setCopied] = useState(false);

  if (!loadId) return null;

  const handleDeleted = () => {
    onClose();
    if (onDeleted) onDeleted();
  };

  const handleCopyVendorLink = () => {
    const url = `${window.location.origin}/load/${loadId}`;
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <ModalStackProvider value={myZ}>
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      fullScreen={fullScreen}
      sx={{ zIndex: myZ }}
      PaperProps={{ sx: paperSx }}
    >
      <DialogTitle sx={{ flexShrink: 0, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Load #{loadId}
          </Typography>
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <Tooltip title={copied ? 'Copied!' : 'Copy vendor link'}>
              <IconButton onClick={handleCopyVendorLink} size="small">
                {copied ? <CheckIcon fontSize="small" /> : <LinkIcon fontSize="small" />}
              </IconButton>
            </Tooltip>
            <Tooltip title="Open full page">
              <IconButton
                component="a"
                href={`/load/${loadId}`}
                target="_blank"
                size="small"
              >
                <OpenInNewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <IconButton onClick={onClose} size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ flex: 1, overflow: 'auto', px: 3, py: 0 }}>
        <ShippingLoadContent loadId={loadId} onDeleted={handleDeleted} />
      </DialogContent>
    </Dialog>
    </ModalStackProvider>
  );
};

export default ShippingLoadModal;
